<template>
  <div>
    <div v-if="dataPermission && dataPermission.includes('NSH_MCMNT_ALIAS_CREATE')">
        <loading v-if="loading"></loading>
        <div class="header">
            <div class="layout-wrapper">
                <header id="page-topbar">
                    <BaseButton variant="secondary" @click="$router.push({ path:`/employee-and-role`})">Quay lại</BaseButton>
                <div class="title">
                    <p>Thêm mới tài khoản</p>
                </div>
                    <el-button type="primary" @click="submitForm('ruleForm')">Hoàn tất</el-button>
                </header>
            </div>
        </div>

        <div class="boxContent boxContentExt" style="margin-top:110px">      
            <div class="__card first-box">
                <LayoutCardTitle>Thông tin tài khoản</LayoutCardTitle>
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" style="width: 100%;" :inline="true">
                    <el-row style="margin-bottom:24px">
                        <el-col :span="12">
                            <el-form-item label="Tên nhân viên" prop="name" class="mb-0">
                                <el-input v-model="ruleForm.name" placeholder="vd: Nguyễn Văn A" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row style="margin-bottom:24px">
                        <el-col :span="12">
                            <el-form-item label="Tên đăng nhập" prop="userName" class="mb-0">
                                <el-input v-model="ruleForm.userName" placeholder="Tên đăng nhập từ 2-50 kí tự" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Mật khẩu" prop="pass" class="mb-0">
                                <el-input type="password" v-model="ruleForm.pass" placeholder="Mật khẩu từ 6 - 20 kí tự" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>

        <div class="boxContent boxContentExt" style="margin-top:24px">      
            <div class="__card first-box">
                <LayoutCardTitle>Vai trò nhân viên</LayoutCardTitle>
                <el-row>
                    <el-col>
                        <span class="role-descrpition">Với mỗi chi nhánh, nhân viên chỉ có thể được gán một vai trò </span>
                    </el-col>
                </el-row>
                
                <el-form label-width="160px" style="width: 100%;" :inline="true">
                    <el-row style="margin-bottom:24px">
                        <el-col :span="12">
                            <el-form-item label="Vai trò" prop="name" class="mb-0">
                                <Select2
                                    :options="roles"
                                    placeholder="Chọn vai trò"
                                    v-model="selectRole"
                                    @change="checkRole($event)"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item prop="name" class="mb-0 locations">
                                <Select2
                                    :options="locations"
                                    v-model="selectLocation"
                                    placeholder="Chọn chi nhánh"
                                    @change="checkLocation($event)"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-button v-if="!selectLocation || !selectRole" disabled style="margin-left: 16px" type="info">Gán vai trò</el-button>
                            <el-button @click="checkValidate" v-else style="margin-left: 16px" type="primary" plain>Gán vai trò</el-button>
                        </el-col>
                    </el-row>
                </el-form>

                <el-row class="w-100">
                    <b-table :items="detailRole" :fields="theadDetail">
                        <template #cell(indexRole)="data">{{ data.index + 1 }}</template>
                        <template #cell(role)="data">
                          <span @click="openRoleModal(data.item.roleId)" style="cursor: pointer; color:#3E69F6">{{data.item.role}}</span>
                        </template>
                        <template #cell(remove)="data">
                        <span @click="detailRole.splice(data.index, 1)">
                        <img src="@/assets/images/delete-vector.png"/>
                        </span>
                        </template>
                    </b-table>
                </el-row>
            </div>
        </div>

        <div class="boxContent boxContentExt" style="margin-top:24px">      
            <div class="__card first-box">
                <LayoutCardTitle>Thông tin bổ sung</LayoutCardTitle>
                  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" style="width: 100%;" :inline="true">
                    <el-row style="margin-bottom:24px">
                        <el-col :span="12">
                            <el-form-item label="Số điện thoại" prop="phoneNo" class="mb-0">
                                <el-input v-model="ruleForm.phoneNo" placeholder="Nhập số điện thoại" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Email" prop="email" class="mb-0">
                                <el-input v-model="ruleForm.email" placeholder="Nhập địa chỉ email" for="email" type="email" />
                                <span class="floating-placeholder" v-if="msg.email">{{msg.email}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row style="margin-bottom:24px">
                        <el-col :span="12">
                            <el-form-item label="Ngày sinh" prop="birthday" class="mb-0">
                                  <el-date-picker type="date" placeholder="Chọn ngày sinh" v-model="ruleForm.birthday"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="Giới tính" prop="gender" class="mb-0">
                                <el-select v-model="ruleForm.gender" placeholder="Giới tính">
                                  <el-option
                                    v-for="item in listGender"
                                    :key="item.id"
                                    :label="item.text"
                                    :value="item.id">
                                  </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        
        <el-dialog title="Phân quyền vai trò" :visible.sync="roleModal" width="600px" :close-on-click-modal="false" append-to-body>
            <div>
              <div style="margin-bottom: 12px;word-break: break-word;" v-for="item, id in groupPermissions" :key="id">
                <b>{{item.groupName}}: </b>{{renderPermissionsList(item)}}
              </div>
            </div>
            <template slot="footer">
                <el-button class="esc-btn" type="text" @click="roleModal = false">Thoát</el-button>
                <el-button
                  type="primary"
                  @click="() => $router.push(`/employee-and-role/role-edit/${this.roleId}`)"
                >
                  Sửa phân quyền
                </el-button>
            </template>
        </el-dialog>
    </div>
    <NotPermission v-else></NotPermission>
  </div>
</template>
<script>
import TitlePage from "@/components/title-page";
import DatePicker from "vue2-datepicker";
import { RoleService } from '@/services/nextshop/role.service';
import { LocationService } from '@/services/nextshop/location.service';
import { EmployeeService } from '@/services/nextshop/employee.service';
import moment from 'moment';

export default {
  page: {
    title: "Thêm mới nhân viên",
  },

  components: {
    TitlePage,
    DatePicker
  },

  data() {
    var checkPhoneNo = (rule, value, callback) => {
      setTimeout(() => {
        if (value == "") {
					callback();
        } else {
          if (!Number.isInteger(parseInt(value))) {
          callback(new Error('Số điện thoại không đúng định dạng'));
          } else {
            callback();
          }
        }
			}, 1000);
    };
    var checkEmail = (rule, value, callback) => {
      setTimeout(() => {
        var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if(value == "") {
					callback();
        } else {
          if (!value.match(mailformat)) {
            callback(new Error('Email không đúng định dạng'));
          } else {
            callback();
          }
        }
			}, 1000);
    };
  return {
    dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
    inforAccount: JSON.parse(localStorage.getItem("auth.currentUser")),
    loading: false,
    ruleForm: {
        name: '',
        userName: '',
        pass: '',
        phoneNo: '',
        email: '',
        gender: '',
        birthday: ''
    },
    rules: {
        name: [
            { required: true, message: 'Họ và tên không được để trống', trigger: 'blur' },
        ],
        userName: [
            { required: true, message: 'Tên đăng nhập không được bỏ trống', trigger: 'blur' },
            { min: 1, max: 50, message: 'Tên đăng nhập không quá 50 ký tự', trigger: 'blur' }
        ],
        pass: [
            { required: true, message: 'Mật khẩu không được bỏ trống', trigger: 'blur' },
            { min: 6, max: 20, message: 'Mật khẩu phải có độ dài từ 6 đến 20 ký tự', trigger: 'blur' }
        ],
        phoneNo: [
          { validator: checkPhoneNo, trigger: 'blur' }
        ],
        email: [
          { validator: checkEmail, trigger: 'blur' }
        ]
    },
    idEmployee: '',
    title: "THÊM MỚI NHÂN VIÊN",
    items: [
      { 
        text: "Danh sách nhân viên", 
        href: JSON.parse(localStorage.getItem("dataPermission")) && JSON.parse(localStorage.getItem("dataPermission")).includes('NSH_MCMNT_ALIAS_VIEW') ? "/employee-list" : "#" },
      { text: "Thêm mới nhân viên", active: true },
    ],
  
    //upload IMG
    logoUrl: "",
    dropzoneFiles: [],
    dropzoneOptions: {
      url: "https://npa-api-gateway.nextshop.dev/s3/image?fileName=1633621539916&folder=nextshop",
      thumbnailWidth: 120,
      thumbnailHeight: 120,
      maxFilesize: 2,
      maxFiles: 1,
      headers: { "My-Awesome-Header": "header value" },
      addRemoveLinks: true,
      acceptedFiles: ".jpeg,.jpg,.png,.gif",
    },

    // input 
    status: true,
    description: '',
    birthday: null,
    birthdayUpdate: null,
    roles: [],
    selectRole: '',
    locations: [],
    selectLocation: null,
    sel: {
      locationId: null,
      roleId: null
    },
    roleId: '',
    groupPermissions: [],
    roleModal: false,
    msgError: '',
    detailRole: [],
    theadDetail: [
      { key: 'indexRole', label: 'STT' },
      { key: 'role', label: 'Vai trò' },
      { key: 'location', label: 'Chi nhánh' },
      { key: 'remove', label: '' }, 
    ],
    listGender: [
      { id: 'MALE', text: 'Nam' },
      { id: 'FEMALE', text: 'Nữ' },
      { id: 'OTHER', text: 'Khác' }
    ],

    errUpload: '',
    modalShowLimit: false,
    msg: [],
    };
  },

  created() {
    this.getListRole()
    this.getListLocation()
  },

  methods: {

    // lấy list role của MC
    async getListRole() {
      try {
        const dataRes = await RoleService.getListRole({
          sort: "DESC",
          sortBy: 'createdAt',
          limit: 100,
          page: 1,
          merchantId: this.inforAccount.merchantId
        })
        if (dataRes.data.length > 0) {
          this.roles = dataRes.data.map((e) => {
            return {
              appId: e.appId,
              id: e.roleId,
              text: e.roleName
            }
          })
        } else {
          this.roles = [{
            id: null,
            text: 'Chưa có dữ liệu'
          }]
        }
       } catch (error) {
        console.log(error);
      }
    },
    // lấy list location của MC
    async getListLocation() {
      try {
        const dataRes = await LocationService.getListLocation({
            coStatus: "ACTIVE",
            limit: 1000,
            page: 1,
            status: "",
            textSearch: null,
            sortBy: "name",
            sort: "ASC",
            merchantId: this.inforAccount.merchantId
        })
        if (dataRes.data.length > 0) {
          dataRes.data.map(e => this.locations.push({
            id: e.coLocationId,
            text: e.name
          }))
          if(this.locations.length == 1) {
            this.sel.locationId = this.locations[0].id
            this.selectLocation = this.locations[0].id
          }
        } else {
          this.locations = [{
            id: null,
            text: 'Chưa có dữ liệu'
          }]
        }
      } catch (error) {
        console.log(error);
      }
    },

    //gán chi nhánh
    checkLocation(e) {
      this.sel.locationId = e 
    },
    // gán vai trò
    checkRole(e) {
      this.sel.roleId = e
    },
    // validate của Role và Location
    checkValidate() {
      const rel = this.detailRole.findIndex((el) => (
        (el.roleId == this.sel.roleId && el.locationId == this.sel.locationId) || (el.locationId == this.sel.locationId)
      ))
      if (this.selectLocation == null || this.selectRole == null) {
        this.msgError = 'Vai trò và Chi nhánh không được để trống !'
      } else if (rel != -1) {
        this.$message.error({
          dangerouslyUseHTMLString: true,
          message: '<h5 style="color:#DC2323">Gán vai trò thất bại</h5><p style="color:#23313E">Nhân viên đã được gán vai trò khác tại chi nhánh này</p>',
        });
        this.msgError = ''
      } else {
        this.msgError = ''
        this.addNewRow()
      }
      this.selectRole = null
      if(this.locations.length !== 1) {this.selectLocation = null}
    },

    async openRoleModal(id) {
      this.roleId = id;
      try {
        const params = {
          roleId: this.roleId,
          lang: "vn",
        };
        const dataRes = await RoleService.getItemRole(params);
        if (dataRes.success) {
          this.groupPermissions = dataRes.data.groupPermissions;
          this.roleModal = true
        }
      } catch (error) {
        console.log(error);
      }
    },

    renderPermissionsList(item) {
      let subPermissionsList = [];
      if(item.permissions && item.permissions.length > 0) {
        for (let i of item.permissions) {
          subPermissionsList.push(i.permissionName)
        }
      }
      return subPermissionsList.join(', ');
    },

    submitForm(formName) {
      console.log(this.ruleForm);
        this.$refs[formName].validate((valid) => {
            if (valid) {
                this.createEmployee();
            } else {
            console.log('error submit!!');
            return false;
            }
        });
    },
    // thêm hàng mới ở bảng quyền và chi nhánh
    addNewRow() {
        const locationTable = this.locations.find(e => e.id === this.selectLocation)
        const roleTable = this.roles.find(e => e.id === this.selectRole)
        this.detailRole.push({
          roleId: this.selectRole,
          locationId: this.selectLocation,
          role: roleTable.text,
          location: locationTable.text
        })
        this.selectRole = null
        if(this.locations.length !== 1) {this.selectLocation = null}
    },
// tạo nhân viên
    async createEmployee() {
          try {
            this.loading = true
            const dataRes = await EmployeeService.createEmployee({
              birthday: this.ruleForm.birthday && `${moment(this.ruleForm.birthday).format("YYYY-MM-DD")}T00:00:00Z`,
              email: (this.ruleForm.email != '') ? this.ruleForm.email.trim() : null,
              gender: (this.ruleForm.gender != '') ? this.ruleForm.gender : null,
              name: this.ruleForm.name.trim(),
              password: this.ruleForm.pass.trim(),
              phoneNo: (this.ruleForm.phoneNo != '') ? this.ruleForm.phoneNo : null,
              roles: this.detailRole.map((e) => {
                return {
                  roleId: e.roleId,
                  locationId: e.locationId
                }
              }),
              soStatus: 'ACTIVE',
              username: this.ruleForm.userName.trim()
            })
            if(dataRes.success) {
                this.$message({
                  dangerouslyUseHTMLString: true,
                  message: '<h5 style="color:#67c23a">Thêm mới nhân viên thành công</h5><p style="color:#23313E">Nhân viên đã được thêm vào danh sách.</p>',
                  type: 'success'
                })
                this.$router.push({ path:`/employee-and-role`});
            } else {
              if(dataRes.code == 'EMPLOYEE_LIMITED' || dataRes.code == 'ALIAS_USER_POLICY_CONFIG_LIMITED'){
                this.modalShowLimit = true
              }else{
                this.$message.error({
                  dangerouslyUseHTMLString: true,
                  message: '<h5 style="color:#DC2323">Thêm mới nhân viên thất bại</h5><p style="color:#23313E">Tên đăng nhập đã tồn tại. Vui lòng chọn tên đăng nhập khác để tiếp tục</p>',
                })
              }
            }
          } catch (error) {
            console.log(error);
          } finally {
            this.loading = false
          }
    },
  }
}
</script>
<style lang="scss" scoped>
.boxContent .__card {
  max-width: 960px;
  padding: 24px;
}
.layout-wrapper {
  position: relative;

  #page-topbar {
    display: flex;
    justify-content: space-between;
    padding: 16px 24px;

    .title{
      position: absolute;
      font-weight: 600;
      font-size: 24px;
      color: #23313e;
      cursor: pointer;
      left: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
      align-self: center;
      
      p {
        margin: 0;
      }
    }
    
    .content {
      margin-top: 5.5em;
      padding: 20px 16.6% 120px 16.6%;
      min-height: 80vh;
    }
  }
}
</style>

<style lang="scss">
.boxContent {
  margin: 12px 0;
}

.el-select {
    width: 100%;
}

.el-form-item {
  width: 100%;
  margin-bottom: 0;
}

.el-date-editor {
  width: 100% !important;
}

.locations .el-form-item__content {
    width:100%;
}

.el-form-item__label {
  color: #9093A4;
}

.el-form-item__content {
  width: 60%;
}
.el-dialog__body {
  max-height: 300px;
  overflow: auto;
}
.day-of-birth input{
  font-size: 14px !important;
}
.role-descrpition {
    padding: 10px 16px;
    width: 440px;
    height: 42px;
    background: #FFF9EC;
    border-radius: 4px;
}
</style>>


<style scoped>
  input {
    font-size: 14px;
  }
  .text-message {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .text-button-message {
  text-align: right;
  border-top: 1px solid #ddd;
  padding-top: 20px;
}
</style>
